import {
    CreateEventRequest,
    EventCommonFields,
    EventForm,
    GooglePlaceInput,
    PlaceResult,
    UpdateEventRequest,
} from "types";

export function toGooglePlaceInput(p: PlaceResult): GooglePlaceInput {
    return {
        place_id: p.place_id,
        name: p.name,
        formatted_address: p.formatted_address,
        city: p.city,
        province: p.province,
        region: p.region,
        country: p.country,
        postal_code: p.postal_code,
        street_number: p.street_number || undefined,
        route: p.route || undefined,
        latitude: p.latitude || undefined,
        longitude: p.longitude || undefined,
    };
}

function toCommonFields(form: EventForm): EventCommonFields {
    return {
        date: new Date(form.date).toISOString(),
        eventType: form.eventType,
        artistId: form.artist!.id,
        promoterName: form.promoterName,
        promoterFee: form.promoterFee,
        serviceName: form.serviceName,
        serviceFee: form.serviceFee,
        note: form.note,
        price: form.price,
        temporary: form.temporary,
        implant: form.implant,
        hotel: form.hotel,
        people: form.people,
    };
}

export function buildCreateEventPayload(form: EventForm): CreateEventRequest {
    if (!form.location) {
        throw new Error("Either locationId or place is required");
    }
    const common = toCommonFields(form);
    if (form.location.isDbLocation) {
        return { ...common, locationId: form.location.place_id };
    }
    return { ...common, place: toGooglePlaceInput(form.location) };
}

export function buildUpdateEventPayload(
    form: EventForm,
    initialLocationId: string | null
): UpdateEventRequest {
    const common = toCommonFields(form);
    const loc = form.location;

    if (!loc) {
        return common;
    }

    if (loc.isDbLocation && loc.place_id === initialLocationId) {
        return common;
    }

    if (loc.isDbLocation) {
        return { ...common, locationId: loc.place_id };
    }

    return { ...common, place: toGooglePlaceInput(loc) };
}
